module.exports = __webpack_public_path__ + "img/map2.dd8a3671.jpg";